import { Col, Form, Row } from 'react-bootstrap';

const attachmentChecklist = [
  'VOTER’S ID', 'FIREARM LICENSE ID', 'INTEGRATED BAR OF THE PHILIPPINES ID', 'POSTAL ID', 'SOLO PARENT ID',
  'PHILHEALTH CARD', 'TIN CARD', 'BARANGAY CLEARANCE', 'OSCA ID', 'CERTIFICATE OF SALE', 'CONTRACT TO SELL',
  'DEED OF DONATION', 'NATIONAL HOUSING AUTHORITY CERTIFICATION', 'TRANSFER CERTIFICATE OF TITLE',
  'ORIGINAL COPY OF NATIONAL HOUSING AUTHORITY CERTIFICATION (FOR TENANT’S ONLY)',
  'OATH OF UNDERTAKING (INFORMAL SETTLER)', 'BARANGAY CERTIFICATE OF RESIDENCY', 'SEC REGISTRATION',
  'BUSINESS PERMIT', 'ARTICLES OF INCORPORATION', 'DRIVERS LICENSE', 'GSIS ID', 'PHILIPPINE PASSPORT',
  'PRC ID', 'UMID', 'PWD ID', 'POLICE CLEARANCE', 'MARRIAGE CONTRACT',
  'CERTIFICATE OF AWARD OR NOTICE/ORDER ISSUED BY NATIONAL GOVERNMENT AGENCIES',
  'CONDOMINIUM CERTIFICATE OF TITLE', 'DEED OF CONDITIONAL SALE', 'TAX DECLARATION', 'LEASE PURCHASE AGREEMENT',
  'CERTIFICATE OF FINAL ELECTRICAL INSPECTION', 'PERMIT FOR TEMPORARY SERVICE CONNECTION',
  'OATH OF UNDERTAKING (ROW LOT)', 'DTI', 'CDA', 'CERTIFICATE OF REGISTRATION (BR 2313)', 'SECRETARY’S CERTIFICATE'
];

const Step4 = ({ formData, setFormData }) => {
  const toggleAttachment = (item) => {
    const current = formData.attachments || [];
    if (current.includes(item)) {
      setFormData({ ...formData, attachments: current.filter(i => i !== item) });
    } else {
      setFormData({ ...formData, attachments: [...current, item] });
    }
  };

  return (
    <div className="card p-4">
      <h5 className="card-title mb-3">Step 4: Requirements</h5>
      <Form>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label>ID Type *</Form.Label>
            <Form.Control
              type="text"
              value={formData.idTypeText || ''}
              onChange={(e) => setFormData({ ...formData, idTypeText: e.target.value })}
            />
          </Col>
          <Col md={6}>
            <Form.Label>ID Category</Form.Label>
            <Form.Select
              value={formData.idCategory || ''}
              onChange={(e) => setFormData({ ...formData, idCategory: e.target.value })}
            >
              <option value="">Select ID Type</option>
              <option value="Government">Government</option>
              <option value="Private">Private</option>
            </Form.Select>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Label>ID Number</Form.Label>
            <Form.Control
              type="text"
              value={formData.idNumber || ''}
              onChange={(e) => setFormData({ ...formData, idNumber: e.target.value })}
            />
          </Col>
          <Col md={6} className="d-flex align-items-center mt-4">
            <Form.Check
              label="Senior Citizen"
              checked={formData.isSenior || false}
              onChange={(e) => setFormData({ ...formData, isSenior: e.target.checked })}
            />
          </Col>
        </Row>

        {formData.isSenior && (
          <Row className="mb-4">
            <Col md={6}>
              <Form.Label>SC Date Start</Form.Label>
              <Form.Control
                type="date"
                value={formData.scDateStart || ''}
                onChange={(e) => setFormData({ ...formData, scDateStart: e.target.value })}
              />
            </Col>
            <Col md={6}>
              <Form.Label>OSCA ID No.</Form.Label>
              <Form.Control
                type="text"
                value={formData.oscaId || ''}
                onChange={(e) => setFormData({ ...formData, oscaId: e.target.value })}
              />
            </Col>
          </Row>
        )}

        <h6 className="mt-4">Checklist of Attachments</h6>
        <Row>
          {attachmentChecklist.map((item, i) => (
            <Col key={i} md={4} className="mb-2">
              <Form.Check
                type="checkbox"
                label={item}
                checked={(formData.attachments || []).includes(item)}
                onChange={() => toggleAttachment(item)}
              />
            </Col>
          ))}
        </Row>

        <div className="mt-3">
          <Form.Label>Upload File</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => setFormData({ ...formData, fileUpload: e.target.files[0] })}
          />
        </div>
      </Form>
    </div>
  );
};

export default Step4;
